import { ChangePasswordArgs } from 'types/api/arguments/change-password-args'

import { api } from './api'

export const changePassword = ({
  userId,
  currentPassword,
  newPassword,
  fingerprint,
}: ChangePasswordArgs) =>
  api.put(`/users/${userId}/password`, {
    old_password: currentPassword,
    password: newPassword,
    fingerprint,
  })
